import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/common/Card';
import EmptyState from '../../components/common/EmptyState';
import LoadingRow from '../../components/common/LoadingRow';
import TodoRow from '../todos/TodoRow';
import useTodosStore from '../../store/useTodosStore';
import { PATHS } from '../../routes/navConfig';

/* The top of the class checklist — same store as the To-Do page, so the count
   here and the list there always agree. */

/* rows the card shows before it hands over to the full page */
const VISIBLE = 4;

export default function RoomParentTodos({ networkId }) {
  const { todos, todosNetworkId, load } = useTodosStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!networkId) return;
    load(networkId).catch(() => {});
  }, [networkId, load]);

  const pending = todosNetworkId !== networkId;
  /* what's still to do, soonest due first; anything undated at the end */
  const open = pending
    ? []
    : todos
        .filter((t) => !t.done)
        .sort((a, b) => (a.due || '9999-12-31').localeCompare(b.due || '9999-12-31'));

  return (
    <Card
      title={
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          Room Parent To-Do {!!open.length && <span className="src-chip">{open.length}</span>}
        </span>
      }
      action={<span className="text-link" onClick={() => navigate(PATHS.TODOS)}>View all</span>}
    >
      <div className="todo-list">
        {pending ? (
          <LoadingRow>Loading to-dos…</LoadingRow>
        ) : open.length ? (
          open.slice(0, VISIBLE).map((t) => <TodoRow key={t.id} todo={t} />)
        ) : (
          <EmptyState>Nothing on the to-do list yet.</EmptyState>
        )}
      </div>
    </Card>
  );
}
